// @ts-nocheck
/*
 * Port of voice-library/hangup-cause-prompt-mapping.js (395 lines). BYTE-IDENTICAL.
 * Links hangup cause codes â†” voice prompt files. Prompt dropdown is
 * scoped to the current user's own approved voice files with a real
 * duration (`prompt_duration > 0`) â€” SUPERADMIN self-scope. Create,
 * edit-modal, delete-modal, and inline audio preview.
 * v1 is imported by manage-prompts but wrapped in a comment
 * `{/* {isSuperAdmin && <HangupCausePromptMapping />} *\/}` so this
 * component ships dead â€” kept as a standalone port for future re-enable
 * without another turn. PrimeReact DataTable â†’ react-bootstrap Table
 * (small always-loaded dataset; no pagination needed).
 */
import React, { useEffect, useState } from 'react';
import { Card as ShadCard } from '@/components/ui/card';
import { Button as _ShadButton } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const _cx = (...args: any[]) => args.filter(Boolean).join(' ');
const Container: any = ({ fluid, className, children, ...props }: any) => (
  <div className={_cx(fluid ? 'container-fluid' : 'container', className)} {...props}>
    {children}
  </div>
);
const Row: any = ({ className, children, ...props }: any) => (
  <div className={_cx('row', className)} {...props}>
    {children}
  </div>
);
const _colCls = ({ xs, sm, md, lg, xl }: any) => {
  const parts = [];
  if (md) parts.push(`col-md-${md}`);
  if (lg) parts.push(`col-lg-${lg}`);
  if (xl) parts.push(`col-xl-${xl}`);
  if (sm) parts.push(`col-sm-${sm}`);
  if (xs) parts.push(`col-${xs}`);
  if (!parts.length) parts.push('col');
  return parts.join(' ');
};
const Col: any = ({ xs, sm, md, lg, xl, className, children, ...props }: any) => (
  <div className={_cx(_colCls({ xs, sm, md, lg, xl }), className)} {...props}>
    {children}
  </div>
);
const _btnVariantMap: Record<string, any> = {
  primary: 'default',
  secondary: 'outline',
  danger: 'destructive',
  light: 'outline',
  link: 'link',
};
const Button: any = ({ variant, size, className, children, ...props }: any) => {
  let mapped = variant;
  if (typeof variant === 'string') {
    if (variant.startsWith('outline-')) mapped = 'outline';
    else if (_btnVariantMap[variant]) mapped = _btnVariantMap[variant];
    else if (variant.startsWith('btn ')) mapped = 'default';
  }
  return (
    <_ShadButton variant={mapped} size={size} className={className} {...props}>
      {children}
    </_ShadButton>
  );
};
const Card: any = ({ className, children, ...props }: any) => (
  <ShadCard className={className} {...props}>
    {children}
  </ShadCard>
);
Card.Header = ({ className, children, ...props }: any) => (
  <div className={_cx('card-header', className)} {...props}>
    {children}
  </div>
);
Card.Body = ({ className, children, ...props }: any) => (
  <div className={_cx('card-body', className)} {...props}>
    {children}
  </div>
);
Card.Title = ({ as: As = 'h5', className, children, ...props }: any) => (
  <As className={_cx('card-title', className)} {...props}>
    {children}
  </As>
);
Card.Text = ({ className, children, ...props }: any) => (
  <p className={_cx('card-text', className)} {...props}>
    {children}
  </p>
);
Card.Footer = ({ className, children, ...props }: any) => (
  <div className={_cx('card-footer', className)} {...props}>
    {children}
  </div>
);
const Form: any = ({ children, onSubmit, className, ...props }: any) => (
  <form
    className={className}
    onSubmit={onSubmit || ((e: any) => e.preventDefault())}
    {...props}
  >
    {children}
  </form>
);
Form.Group = ({ className, controlId: _c, children, ...props }: any) => (
  <div className={_cx('mb-3', className)} {...props}>
    {children}
  </div>
);
Form.Label = ({ className, children, htmlFor, ...props }: any) => (
  <label className={_cx('form-label', className)} htmlFor={htmlFor} {...props}>
    {children}
  </label>
);
Form.Control = ({ as, className, children, isInvalid, ...props }: any) => {
  const cls = _cx('form-control', isInvalid && 'is-invalid', className);
  if (as === 'select')
    return (
      <select className={cls} {...props}>
        {children}
      </select>
    );
  if (as === 'textarea') return <textarea className={cls} {...props} />;
  return <input className={cls} {...props} />;
};
Form.Select = ({ className, children, isInvalid, ...props }: any) => (
  <select
    className={_cx('form-control form-select', isInvalid && 'is-invalid', className)}
    {...props}
  >
    {children}
  </select>
);
Form.Check = ({
  type = 'checkbox',
  label,
  id,
  className,
  inline,
  children,
  ...props
}: any) => (
  <div className={_cx('form-check', inline && 'form-check-inline', className)}>
    <input type={type} id={id} className="form-check-input" {...props} />
    {label !== undefined && (
      <label htmlFor={id} className="form-check-label">
        {label}
      </label>
    )}
    {children}
  </div>
);
Form.Text = ({ muted, className, children, ...props }: any) => (
  <small className={_cx('form-text', muted && 'text-muted', className)} {...props}>
    {children}
  </small>
);
const Modal: any = ({ show, onHide, size, centered: _c, children, className, ...props }: any) => {
  const sizeCls =
    size === 'sm'
      ? 'sm:max-w-md'
      : size === 'lg'
      ? 'sm:max-w-2xl'
      : size === 'xl'
      ? 'sm:max-w-6xl'
      : '';
  return (
    <Dialog open={!!show} onOpenChange={(o: boolean) => !o && onHide?.()}>
      <DialogContent
        className={`${sizeCls} max-h-[90vh] overflow-y-auto ${className || ''}`.trim()}
        {...props}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};
Modal.Header = ({ children, closeButton: _cb, className, ...props }: any) => (
  <DialogHeader className={className} {...props}>
    {children}
  </DialogHeader>
);
Modal.Title = ({ children, className, ...props }: any) => (
  <DialogTitle className={className} {...props}>
    {children}
  </DialogTitle>
);
Modal.Body = ({ children, className, ...props }: any) => (
  <div className={`overflow-x-auto ${className || ''}`.trim()} {...props}>
    {children}
  </div>
);
Modal.Footer = ({ children, className, ...props }: any) => (
  <DialogFooter className={className} {...props}>
    {children}
  </DialogFooter>
);
const Table: any = ({
  bordered,
  striped,
  hover,
  responsive: _r,
  className,
  children,
  ...props
}: any) => (
  <table
    className={_cx(
      'table',
      bordered && 'table-bordered',
      striped && 'table-striped',
      hover && 'table-hover',
      className,
    )}
    {...props}
  >
    {children}
  </table>
);
const _TabsCtx = React.createContext<any>({});
const Tabs: any = ({
  activeKey,
  defaultActiveKey,
  onSelect,
  children,
  className,
  ...props
}: any) => {
  const [internalKey, setInternalKey] = React.useState(defaultActiveKey || null);
  const current = activeKey !== undefined ? activeKey : internalKey;
  const handle = (k: any) => {
    if (activeKey === undefined) setInternalKey(k);
    onSelect?.(k);
  };
  const tabs = React.Children.toArray(children).filter(Boolean) as any[];
  if (current === null && tabs.length) {
    setInternalKey(tabs[0]?.props?.eventKey);
  }
  return (
    <_TabsCtx.Provider value={{ current, setKey: handle }}>
      <div className={className} {...props}>
        <ul className="nav nav-tabs" role="tablist">
          {tabs.map((t: any) => (
            <li key={t.props.eventKey} className="nav-item" role="presentation">
              <button
                type="button"
                className={_cx('nav-link', current === t.props.eventKey && 'active')}
                onClick={() => handle(t.props.eventKey)}
                disabled={t.props.disabled}
              >
                {t.props.title}
              </button>
            </li>
          ))}
        </ul>
        <div className="tab-content">
          {tabs.map((t: any) => (
            <div
              key={t.props.eventKey}
              className={_cx('tab-pane', current === t.props.eventKey && 'active show')}
              style={{ display: current === t.props.eventKey ? undefined : 'none' }}
            >
              {t.props.children}
            </div>
          ))}
        </div>
      </div>
    </_TabsCtx.Provider>
  );
};
const Tab: any = () => null;
const Tooltip: any = ({ children, id: _id, ...props }: any) => (
  <span {...props}>{children}</span>
);
const OverlayTrigger: any = ({ children, overlay, placement: _p, trigger: _t }: any) => {
  let title = '';
  if (overlay?.props?.children) {
    title =
      typeof overlay.props.children === 'string'
        ? overlay.props.children
        : Array.isArray(overlay.props.children)
          ? overlay.props.children.filter((c: any) => typeof c === 'string').join(' ')
          : '';
  }
  return React.cloneElement(children, { title });
};
const Badge: any = ({ bg, pill, className, children, ...props }: any) => (
  <span
    className={_cx('badge', bg && `bg-${bg}`, pill && 'rounded-pill', className)}
    {...props}
  >
    {children}
  </span>
);
const Spinner: any = ({ animation: _a, size, variant, className, ...props }: any) => (
  <span
    className={_cx(
      'spinner-border',
      size === 'sm' && 'spinner-border-sm',
      variant && `text-${variant}`,
      className,
    )}
    role="status"
    aria-hidden="true"
    {...props}
  />
);
import { toast } from 'sonner';
import { friendlyApiError } from '@/utilities/apiErrorMessage';
import {
  getApiCall,
  postApiCall,
  patchApiCall,
  deleteApiCallWithHeader,
} from '@/service/httpCall';
import {
  API_HANGUP_CAUSES,
  API_HANGUP_PROMPT_MAPPING,
  API_PROMPT_ACTIVE_LIST,
} from '@/service/url';
import { getUser } from '@/utilities/setting';
import { canUploadPromptsOrMoh } from '@/utilities/promptUploadAccess';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/utilities/constant';
import { FillPage } from '@/components/layout/PageContainer';
import { PageHeader } from '@/components/feedback/PageHeader';
import { Button as PageButton } from '@/components/ui/button';
import { Upload } from 'lucide-react';

function firstPromptUrl(prompt_url: any) {
  if (!prompt_url) return '';
  if (typeof prompt_url === 'string') return prompt_url;
  if (Array.isArray(prompt_url) && prompt_url.length)
    return prompt_url[0]?.url || '';
  return '';
}

const HangupCausePromptMapping = () => {
  const navigate = useNavigate();
  const currentUser = getUser() || {};

  const [causes, setCauses] = useState<any[]>([]);
  const [prompts, setPrompts] = useState<any[]>([]);
  const [mappings, setMappings] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [selCause, setSelCause] = useState('');
  const [selPrompt, setSelPrompt] = useState('');
  const [saving, setSaving] = useState(false);
  const [playingUrl, setPlayingUrl] = useState('');

  // edit modal
  const [editRow, setEditRow] = useState<any>(null);
  const [editCause, setEditCause] = useState('');
  const [editPrompt, setEditPrompt] = useState('');

  // delete modal
  const [deleteRow, setDeleteRow] = useState<any>(null);
  const [deleting, setDeleting] = useState(false);

  const loadCauses = () => {
    getApiCall(API_HANGUP_CAUSES)
      .then((res: any) => setCauses(Array.isArray(res) ? res : res?.data || []))
      .catch(() => {});
  };

  const loadPrompts = () => {
    // only voice files created by the current SuperAdmin (approved)
    const uid = currentUser.id;
    getApiCall(`${API_PROMPT_ACTIVE_LIST}?user_id=${uid}&prompt_status=1`)
      .then((res: any) => {
        const list = Array.isArray(res) ? res : res?.data || [];
        // only own voice files with a real duration (> 0)
        setPrompts(
          list.filter(
            (p: any) =>
              String(p.created_by) === String(uid) && Number(p.prompt_duration) > 0,
          ),
        );
      })
      .catch(() => {});
  };

  const loadMappings = () => {
    setLoading(true);
    getApiCall(API_HANGUP_PROMPT_MAPPING)
      .then((res: any) => setMappings(Array.isArray(res) ? res : res?.data || []))
      .catch((err: any) =>
        toast.error(friendlyApiError(err) || 'Failed to load mappings'),
      )
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadCauses();
    loadPrompts();
    loadMappings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreate = () => {
    if (!selCause || !selPrompt) {
      toast.error('Select both a hangup cause code and a voice file');
      return;
    }
    setSaving(true);
    postApiCall(API_HANGUP_PROMPT_MAPPING, {
      hangup_cause_code_id: selCause,
      prompt_id: selPrompt,
    })
      .then(() => {
        toast.success('Linking created');
        setSelCause('');
        setSelPrompt('');
        loadMappings();
      })
      .catch((err: any) =>
        toast.error(friendlyApiError(err) || 'Failed to create linking'),
      )
      .finally(() => setSaving(false));
  };

  const openEdit = (row: any) => {
    setEditRow(row);
    setEditCause(row.hangup_cause_code_id);
    setEditPrompt(row.prompt_id);
  };

  const handleUpdate = () => {
    if (!editRow) return;
    setSaving(true);
    patchApiCall(`${API_HANGUP_PROMPT_MAPPING}/${editRow.id}`, {
      hangup_cause_code_id: editCause,
      prompt_id: editPrompt,
    })
      .then(() => {
        toast.success('Mapping updated');
        setEditRow(null);
        loadMappings();
      })
      .catch((err: any) =>
        toast.error(friendlyApiError(err) || 'Failed to update mapping'),
      )
      .finally(() => setSaving(false));
  };

  const handleDelete = () => {
    if (!deleteRow) return;
    setDeleting(true);
    deleteApiCallWithHeader(`${API_HANGUP_PROMPT_MAPPING}/${deleteRow.id}`)
      .then(() => {
        toast.success('Mapping deleted');
        setDeleteRow(null);
        loadMappings();
      })
      .catch((err: any) =>
        toast.error(friendlyApiError(err) || 'Failed to delete mapping'),
      )
      .finally(() => setDeleting(false));
  };

  const causeLabel = (c: any) =>
    `${c.hangup_cause_code} - ${c.message || c.hangup_cause_reason || 'Unknown'}`;

  const fmt = (d: any) =>
    d
      ? new Date(d).toLocaleString('en-IN', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      : '-';

  return (
    <FillPage>
      <PageHeader
        title="Hangup Cause → Voice Prompt Linking"
        description="Map each hangup cause code to a voice prompt played to the caller."
        actions={
          canUploadPromptsOrMoh() ? (
            <PageButton
              variant="outline"
              size="sm"
              onClick={() => navigate(`/${ROUTES.IVR.ADD_VOICE}`)}
              className="gap-1"
            >
              <Upload className="h-4 w-4" />
              Upload New Voice File
            </PageButton>
          ) : null
        }
      />
      <div className="card">
      <div className="card-body">
        {/* create row */}
        <div
          style={{
            display: 'flex',
            gap: 10,
            flexWrap: 'wrap',
            alignItems: 'flex-end',
            marginBottom: 16,
          }}
        >
          <div style={{ minWidth: 260 }}>
            <label style={{ fontSize: 12, opacity: 0.7 }}>Hangup Cause Code</label>
            <Form.Select
              value={selCause}
              onChange={(e) => setSelCause(e.target.value)}
            >
              <option value="">Select cause code</option>
              {causes.map((c: any) => (
                <option key={c.id} value={c.id}>
                  {causeLabel(c)}
                </option>
              ))}
            </Form.Select>
          </div>

          <div style={{ minWidth: 260 }}>
            <label style={{ fontSize: 12, opacity: 0.7 }}>
              Voice File (SA Uploaded Only)
            </label>
            <Form.Select
              value={selPrompt}
              onChange={(e) => setSelPrompt(e.target.value)}
            >
              <option value="">Select voice file</option>
              {prompts.map((p: any) => (
                <option key={p.id} value={p.id}>
                  {p.prompt_name}
                </option>
              ))}
            </Form.Select>
          </div>

          <Button variant="primary" onClick={handleCreate} disabled={saving}>
            {saving ? 'Saving...' : 'Link'}
          </Button>
        </div>

        {prompts.length === 0 && (
          <div style={{ fontSize: 12, color: '#f59e0b', marginBottom: 12 }}>
            No voice files created by you yet. Upload one first (no approval needed).
          </div>
        )}

        <Table striped hover responsive>
          <thead>
            <tr>
              <th style={{ width: 60 }}>#</th>
              <th>Hangup Code</th>
              <th>Message</th>
              <th>Voice File</th>
              <th>Duration</th>
              <th>Play</th>
              <th>Created By</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={9} className="text-center text-muted py-3">
                  Loading...
                </td>
              </tr>
            ) : mappings.length === 0 ? (
              <tr>
                <td colSpan={9} className="text-center text-muted py-3">
                  No linkings yet
                </td>
              </tr>
            ) : (
              mappings.map((r: any, rowIndex: number) => {
                const url = firstPromptUrl(r.prompt?.prompt_url);
                return (
                  <tr key={r.id}>
                    <td>{rowIndex + 1}</td>
                    <td>{r.hangupCauseCode?.hangup_cause_code ?? '-'}</td>
                    <td>
                      {r.hangupCauseCode?.message ||
                        r.hangupCauseCode?.hangup_cause_reason ||
                        '-'}
                    </td>
                    <td>{r.prompt?.prompt_name || '-'}</td>
                    <td>
                      {Number(r.prompt?.prompt_duration) > 0
                        ? `${Number(r.prompt.prompt_duration)}s`
                        : '-'}
                    </td>
                    <td>
                      {url ? (
                        <Button
                          size="sm"
                          variant={playingUrl === url ? 'danger' : 'outline-secondary'}
                          onClick={() =>
                            setPlayingUrl(playingUrl === url ? '' : url)
                          }
                        >
                          {playingUrl === url ? 'Stop' : 'Play'}
                        </Button>
                      ) : (
                        '-'
                      )}
                    </td>
                    <td>{r.creator?.name || r.creator?.username || '-'}</td>
                    <td>{fmt(r.created_at)}</td>
                    <td>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() => openEdit(r)}
                        >
                          Edit
                        </Button>
                        <Button
                          size="sm"
                          variant="outline-danger"
                          onClick={() => setDeleteRow(r)}
                        >
                          Delete
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>

        {playingUrl && (
          <div style={{ marginTop: 12 }}>
            <p style={{ fontSize: 12, opacity: 0.7, marginBottom: 4 }}>Now Playing</p>
            <audio key={playingUrl} controls autoPlay style={{ width: '100%' }}>
              <source src={playingUrl} type="audio/mpeg" />
            </audio>
          </div>
        )}
      </div>

      {/* edit modal */}
      <Modal show={!!editRow} onHide={() => setEditRow(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Linking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, opacity: 0.7 }}>Hangup Cause Code</label>
            <Form.Select
              value={editCause}
              onChange={(e) => setEditCause(e.target.value)}
            >
              <option value="">Select cause code</option>
              {causes.map((c: any) => (
                <option key={c.id} value={c.id}>
                  {causeLabel(c)}
                </option>
              ))}
            </Form.Select>
          </div>
          <div>
            <label style={{ fontSize: 12, opacity: 0.7 }}>Voice File (yours)</label>
            <Form.Select
              value={editPrompt}
              onChange={(e) => setEditPrompt(e.target.value)}
            >
              <option value="">Select voice file</option>
              {prompts.map((p: any) => (
                <option key={p.id} value={p.id}>
                  {p.prompt_name}
                </option>
              ))}
            </Form.Select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setEditRow(null)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleUpdate} disabled={saving}>
            {saving ? 'Saving...' : 'Update'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* delete confirm modal */}
      <Modal show={!!deleteRow} onHide={() => setDeleteRow(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Linking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Delete linking of hangup code{' '}
          <strong>{deleteRow?.hangupCauseCode?.hangup_cause_code}</strong> â†’{' '}
          <strong>{deleteRow?.prompt?.prompt_name}</strong>? This cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteRow(null)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete} disabled={deleting}>
            {deleting ? 'Deleting...' : 'Delete'}
          </Button>
        </Modal.Footer>
      </Modal>
      </div>
    </FillPage>
  );
};

export default HangupCausePromptMapping;
